import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MetaModule } from '@x/common/meta';
import { ShopMetaService } from '@x/ecommerce-shop/app/core/shop-meta/shop-meta.service';
import { ShopMetaComponent } from './shop-meta/shop-meta.component';

@NgModule({
  providers: [ShopMetaService],
  declarations: [ShopMetaComponent],
  imports: [CommonModule, MetaModule],
})
export class ShopMetaModule {}
